import { render, staticRenderFns } from "./WsChip001.vue?vue&type=template&id=4935c16f"
import script from "./WsChip001.vue?vue&type=script&lang=js"
export * from "./WsChip001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports